import React from 'react';
import './App.css';
import WorkExperience from './resume/WorkExperience';
import VolunteerExperience from './resume/VolunteerExperience';

import PropTypes from 'prop-types'
import {Container, Grid, Header, Segment,} from 'semantic-ui-react'
import {HashRouter as Router, Route, Routes,} from "react-router-dom";
import {ModalProvider} from "./hooks/modal";

const HomepageHeading = ({mobile}) => (
    <Container text>
        <div className="col-12 centered" id="profile">
            <img className="user profile" style={{marginTop: mobile ? '1em' : '2em'}} />
            <Header
                as='h1'
                className="text-center"
                inverted
                content="Jacob Olsen"
                style={{
                    fontSize: mobile ? '2em' : '4em',
                    fontWeight: 'normal',
                    marginBottom: 0,
                    marginTop: mobile ? '0.25em' : '1em',
                }}
            />
            {/*<Header*/}
            {/*    as='h2'*/}
            {/*    className="text-center"*/}
            {/*    inverted*/}
            {/*    content="Brisbane, Australia"*/}
            {/*    style={{*/}
            {/*        fontSize: mobile ? '1.5em' : '1.7em',*/}
            {/*        fontWeight: 'normal',*/}
            {/*        marginTop: mobile ? '0.5em' : '1.5em',*/}
            {/*    }}*/}
            {/*/>*/}
            <p style={{fontSize: mobile ? '1em' : '1.33em', marginTop: mobile ? '0.5em' : '1.5em'}}>
                Full Stack Engineer with a passion for theatre
            </p>

            {/*<p style={{fontSize: '0.7em', marginTop: mobile ? '0.5em' : '1.5em'}}>*/}
            {/*    More details upon request*/}
            {/*</p>*/}
        </div>
    </Container>
)

HomepageHeading.propTypes = {
    mobile: PropTypes.bool,
}

const ResponsiveContainer = ({children}) => (<>
        <Segment
            inverted
            textAlign='center'
            style={{backgroundColor: 'black'}}
            vertical
        >
            <HomepageHeading/>
        </Segment>
        {/*<Segment*/}
        {/*    inverted*/}
        {/*    vertical*/}
        {/*    style={{backgroundColor: '#a1c6de'}}*/}
        {/*>*/}
        {/*    <Socials/>*/}
        {/*</Segment>*/}
        {children}
    </>
)

ResponsiveContainer.propTypes = {
    children: PropTypes.node,
}
// let Socials = () =>
//     <Container>
//         <Header as='h2'>Contact</Header>
//         <Grid stackable columns='equal'>
//             <Grid.Row>
//                 <Grid.Column>
//                     <Header>
//                         <Icon name={'map marker alternate'} size='large'/>
//                         Brisbane, Australia
//                     </Header>
//                     <Header>
//                         <a href='https://www.linkedin.com/in/jacob-o/'>
//                             <Icon name={'linkedin'} size='large'/>
//                             jacob-o
//                         </a>
//                     </Header>
//                 </Grid.Column>
//                 <Grid.Column>
//
//                 </Grid.Column>
//                 <Grid.Column>
//                     <Header>
//                         <Icon name={'instagram'} size='large'/>
//                         social_jacobo
//                     </Header>
//                     <Header>
//                         <a href='https://twitter.com/social_jacobo'>
//                             <Icon name={'twitter'} size='large'/>
//                             @social_jacobo
//                         </a>
//                     </Header>
//                 </Grid.Column>
//                 <Grid.Column>
//                     <Header>
//                         <Icon name={'discord'} size='large'/>
//                         mickey0032
//                     </Header>
//                     <Header>
//                         <Icon name={'playstation'} size='large'/>
//                         mickey0032
//                     </Header>
//                     <Header>
//                         <Icon name={'nintendo switch'} size='large'/>
//                         mickey0032
//                     </Header>
//                 </Grid.Column>
//             </Grid.Row>
//         </Grid>
//     </Container>

// let Interests = () =>
//     <Container style={{paddingTop: '1rem'}}>
//         <Header as='h2'>Hobbies & Interests</Header>
//         <Container style={{paddingTop: '1rem'}}>
//             <Grid stackable columns='equal'>
//                 <Grid.Row>
//                     <Grid.Column>
//                         <Header as='h5'>
//                             <Icon name={'game'} size='large'/>
//                             Video Games
//                         </Header>
//                     </Grid.Column>
//                     <Grid.Column>
//                         <Header as='h5'>
//                             <Icon name={'music'} size='large'/>
//                             Music
//                         </Header>
//                     </Grid.Column>
//                 </Grid.Row>
//             </Grid>
//         </Container>
//     </Container>

let History = () => <Grid container stackable columns='equal'>
    <Grid.Row>
        <Grid.Column width={8}>
            <WorkExperience/>
            {/*<Interests/>*/}
        </Grid.Column>
        <Grid.Column width={8}>
            <VolunteerExperience/>
        </Grid.Column>
    </Grid.Row>
</Grid>;

const AppRoutes = () =>
    <Router>
        <Routes>
            <Route exact path='/' element={< History/>}/>
            <Route exact path='/hi' element={<div>Hi</div>}/>
            <Route path="*" element={<div>Error</div>}/>
        </Routes>
    </Router>

const HomepageLayout = () => (
    <ResponsiveContainer>
        <Segment style={{padding: '1em 0em'}} vertical>
            <ModalProvider>
                <AppRoutes/>
            </ModalProvider>
        </Segment>
    </ResponsiveContainer>
)
export default HomepageLayout
